import CaseificioSync from "./CaseificioSync.vue";
export default {
  CaseificioSync
};
